import { object, string } from 'prop-types';
import React, { Component, Fragment } from 'react';
import Printer from 'components/Icons/Printer';
import { MQ_MEDIUM } from 'constants/mq';

class Print extends Component {
  constructor(props) {
    super(props);
    this.handlePrint = this.handlePrint.bind(this);
  }
  handlePrint(e) {
    e.preventDefault();
    const { type, item, title } = this.props;
    // Save data to local storage
    window.localStorage.setItem(
      'print',
      JSON.stringify({
        type,
        item,
        title
      })
    );
    // Open new window
    window.open('/_/print');
  }
  render() {
    const { placement, destination, type } = this.props;
    const typeSlug = type.toLowerCase().replace(/\s/gi, '-');
    return (
      <div className="PrintButton">
        <button
          type="button"
          onClick={this.handlePrint}
          className={`PrintButton__button PrintButton__button--${typeSlug}`}
          data-gtm-placement={placement}
        >
          <Printer display="inline-block" />
          {placement !== 'recipe-first' && (
            <Fragment>
              Print
              {destination && (
                <span className="PrintButton__destination">
                  &nbsp;{destination}
                </span>
              )}
            </Fragment>
          )}
        </button>
        <style jsx>{`
          .PrintButton :global(svg) {
            margin-right: 0.25rem;
          }

          .PrintButton__button {
            display: flex;
            align-items: center;
            color: currentColor;
            font-size: 1em;
            letter-spacing: 0.02em;
            text-transform: uppercase;
            cursor: pointer;
          }

          .PrintButton__destination {
            display: none;
          }

          @media ${MQ_MEDIUM} {
            .PrintButton__destination {
              display: block;
            }
          }
        `}</style>
      </div>
    );
  }
}

Print.propTypes = {
  placement: string,
  type: string.isRequired,
  title: string.isRequired,
  destination: string,
  item: object.isRequired // eslint-disable-line
};

Print.defaultProps = {
  placement: undefined,
  destination: undefined
};

export default Print;
